<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX19CZfsrszu+5DIuy51f/HGnBm37mspbTH8=","cpf":"U2FsdGVkX194bggx58Di2hr4yl/gKwx62KiXAKfkI2w="},{"num_cand":"U2FsdGVkX18nl47IOlGW7zFSDGD1eUlqes1+6aDFghc=","cpf":"U2FsdGVkX19Shlh/Dx/1IebWHM297Ybgodx+jOiDhLg="},{"num_cand":"U2FsdGVkX18S1kehZ3vTqVKe+DqJXNhOZS0pwr1JzA8=","cpf":"U2FsdGVkX19XowvLU8Ksqqd05sKOPa7Z6r24X+uXpJY="},{"num_cand":"U2FsdGVkX1/ykpfyAa1PZYFV7dVnELAuR/7hbfCzuhM=","cpf":"U2FsdGVkX1+uJiwMTFeND9QbBTx9EUMMrtOUasmllvU="},{"num_cand":"U2FsdGVkX1/jHMDCDN36a0Z9EAAjLuRGefVWU0hazdQ=","cpf":"U2FsdGVkX1+TBxCFPVV/QiPyMIb1eZ6BUoGTx9PNboI="},{"num_cand":"U2FsdGVkX1+zqZMWfLc5GstjVPahLvqnqSpHAWlrtAc=","cpf":"U2FsdGVkX1+QA4xzawLezm/jy+oGlB6Wkcx1gUryzM4="},{"num_cand":"U2FsdGVkX1+6AvFdvSksUQZ0cbD0UGksf5T/S3uUtpU=","cpf":"U2FsdGVkX1/1KCagKIWK19baCmchxX9owDqg805f7l4="},{"num_cand":"U2FsdGVkX19v6rU//bQadRf8nleKJnmw4wTsBb58sMI=","cpf":"U2FsdGVkX1+xnnZfjMyRfcdM4TDfD2pAEJf2lmAJuWY="},{"num_cand":"U2FsdGVkX1/A0oyriusTAtXKJOqTv+Jp9gTK8JLyJPU=","cpf":"U2FsdGVkX19to42LTgONEo18e55sRw70k8z/1ipLrs8="},{"num_cand":"U2FsdGVkX18eUCJdNctXINUXgayVEL2FGNkBcujoBRA=","cpf":"U2FsdGVkX18PeMnD/rHZb4HiF3Nof0I33h+oW+eseWM="},{"num_cand":"U2FsdGVkX19xPjGUPXo2NqeKr9AEN9szo5up5U6MBCE=","cpf":"U2FsdGVkX1+5p4roOHDTnluz8gZre8JYHVZVUuLux1A="},{"num_cand":"U2FsdGVkX19wI97UCDKiXOapbfy69WYPyS2CU3Oq7qM=","cpf":"U2FsdGVkX19MqOnlJcyhPiiifv99EEM5MJpDuRYWanA="},{"num_cand":"U2FsdGVkX18Os1zUwgop66M/bEy6ponUG2rl8N9H+Fc=","cpf":"U2FsdGVkX18HOleqBwIp2A5VnVdAU/Qu23xSGKwiiiM="},{"num_cand":"U2FsdGVkX19Ol/6Zei/Evu+zIP+OH8omXZXHjQmI4Mc=","cpf":"U2FsdGVkX1/XP7q67U7Z5fbNRfWFBU1Xwhyfo2np6XU="},{"num_cand":"U2FsdGVkX19czYJNELFoRu2mF3VF+gdRPDNsNn+OePE=","cpf":"U2FsdGVkX1+m4a1HKktb9wEU1ke816sYItnOgnYYvKI="},{"num_cand":"U2FsdGVkX1+aKU98/e48ydab8hwxQsoYXxMJefLzWeU=","cpf":"U2FsdGVkX18GRhFvSHJrPNBdV7LR+6+tDT2ok5hQ490="},{"num_cand":"U2FsdGVkX190wQtnuzwFlmaPVoBWay6gjnkG3PJD+Pw=","cpf":"U2FsdGVkX1+q5iXtlesTTbfa3RfrNRRkc417J36pl6A="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2202/2202_rec_cl/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
